import _classCallCheck from "/Users/mikefree/Desktop/strata-2019/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/mikefree/Desktop/strata-2019/node_modules/@babel/runtime/helpers/esm/createClass";
import dispatch from "./dispatch.js";
import { inspect } from "./inspect.js";
import inspectName from "./inspectName.js";
var LOCATION_MATCH = /\s+\(\d+:\d+\)$/m;
export var Inspector =
/*#__PURE__*/
function () {
  function Inspector(node) {
    _classCallCheck(this, Inspector);

    if (!node) throw new Error("invalid node");
    this._node = node;
    node.classList.add("observablehq");
  }

  _createClass(Inspector, [{
    key: "pending",
    value: function pending() {
      var _node = this._node;

      _node.classList.remove("observablehq--error");

      _node.classList.add("observablehq--running");
    }
  }, {
    key: "fulfilled",
    value: function fulfilled(value, name) {
      var _node = this._node;

      if (!(value instanceof Element || value instanceof Text) || value.parentNode && value.parentNode !== _node) {
        value = inspect(value, false, _node.firstChild // TODO Do this better.
        && _node.firstChild.classList && _node.firstChild.classList.contains("observablehq--expanded"), name);
        value.classList.add("observablehq--inspect");
      }

      _node.classList.remove("observablehq--running", "observablehq--error");

      if (_node.firstChild !== value) {
        if (_node.firstChild) {
          while (_node.lastChild !== _node.firstChild) {
            _node.removeChild(_node.lastChild);
          }

          _node.replaceChild(value, _node.firstChild);
        } else {
          _node.appendChild(value);
        }
      }

      dispatch(_node, "update");
    }
  }, {
    key: "rejected",
    value: function rejected(error, name) {
      var _node = this._node;

      _node.classList.remove("observablehq--running");

      _node.classList.add("observablehq--error");

      while (_node.lastChild) {
        _node.removeChild(_node.lastChild);
      }

      var div = document.createElement("div");
      div.className = "observablehq--inspect";
      if (name) div.appendChild(inspectName(name));
      div.appendChild(document.createTextNode((error + "").replace(LOCATION_MATCH, "")));

      _node.appendChild(div);

      dispatch(_node, "error", {
        error: error
      });
    }
  }]);

  return Inspector;
}();

Inspector.into = function (container) {
  if (typeof container === "string") {
    container = document.querySelector(container);
    if (container == null) throw new Error("container not found");
  }

  return function () {
    return new Inspector(container.appendChild(document.createElement("div")));
  };
};